<script>
export default {
  name: 'EditorMixin',
  props: {
    widget: {type: Object, required: true}
  },
  data () {
    return {
      test: 'salam'
    }
  },
  methods: {
    validateAll () {
      return this.$validator.validateAll()
    }
  }
}
</script>
